export default __webpack_public_path__ + "static/media/loader.5aa42bd4.gif";